<!-- prettier-ignore -->

<ion-header>
    <ion-toolbar class="header-modal-lang">
        <ion-title class="notranslate">{{'Selección de idioma' | translate}}</ion-title>
        <ion-buttons slot="end">
            <ion-icon (click)="dismissModal()" name="close"></ion-icon>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="content-modal-lang">
    <div class="content-modal-lang__container">
        <ng-select (change)="changeLang()" [(ngModel)]="selectedLang" [isOpen]="true" placeholder="{{'Selecciona idioma...' | translate}}" class="notranslate">
            @for (lang of langs; track lang.code) {
                <ng-option [value]="lang.code">
                    <div class="content-modal-lang__options">
                        <span class="notranslate">{{lang.name}}</span>
                        <img draggable="false" [src]="'/assets/isoLangs/' + lang.code + '.svg'">
                    </div>
                </ng-option>
            }
        </ng-select>
    </div>
</ion-content> 